import React from 'react'
import './Footer.scss'
import { Link } from 'react-router-dom'
import { FaInstagram } from "react-icons/fa";
import { LuFacebook } from "react-icons/lu";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../../../src/assets/header/logos/matte_logo.png"



function Footer() {
  return (
    <>
      <div className="parent footer-parent">
        <div className="cont footer-cont">
          <div className="first-section">
            {/* <h2>Lorem, ipsum.</h2> */}

            <Link className="logo" to="/">
              <img src={logo} alt="" />
              <span>A bridge from local to global </span>
            </Link>



            <p>Jungle Bush empowers local farmers, artisans, and creators to grow from their roots, earn with dignity, and build a sustainable future—right from home.</p>

          </div>
          <div className="second-section">
            <div className="my-account">
              <h4>My Account</h4>
              <Link to="/seller-benefits">Seller Benefits
              </Link>
              <Link to="/gst">Don't have GST?</Link>
              <Link to="/login">Login</Link>
              <Link to="/register">Register Your Business</Link>
            </div>

            <div className="helps">
              <h4>Helps</h4>
              <Link to="/help-support">Help & Support</Link>
              <Link>Terms & Conditions</Link>
              <Link>Privacy Policy</Link>
            </div>
          </div>

          <div className="proxy">
            <h4>Stay Connected</h4>
            <div className="social-icons">
              <a href=''><FaInstagram /></a>
              <a href=''><LuFacebook /></a>
              <a href=''><FaLinkedinIn /></a>
              <a href=''><FaXTwitter /></a>
            </div>
            <div className="contact_wrap">
              <h4>Contact Us</h4>
              <a href="tel:+9096915795" target='_blank' >+91 9096915795</a>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}

export default Footer
